import Prismic from "@prismicio/client";
import { RichText } from "prismic-reactjs";

const apiEndpoint = "https://nf-oljefond-kampanje.cdn.prismic.io/api/v2";
const client = Prismic.client(apiEndpoint);
// -- Links resolution rules
// This function will be used to generate links to Prismic.io documents
// As your project grows, you should update this function according to your routes
// Link Resolver
export const linkResolver = function (doc) {
  // Pretty URLs for known types
  if (doc.type === "infoboks") return "info/" + doc.uid;

  // Fallback for other types, in case new custom types get created
  return "/doc/" + doc.id;
};
/** See prismic docs  */
export const html = (document) =>
  RichText.render(document.data.text_field, linkResolver);

export const accessDocument = async (docType) => {
  const response = await client.query(
    Prismic.Predicates.at("document.type", docType),
    {
      pageSize: 100,
    }
  );
  if (response) {
    return response.results.map((result) => result.data);
  }
};
